import useUpdateUser from './useUpdateUser';
import useSetAxiosAuthHeader from './useSetAxiosAuthHeader';

export default () => {
  useUpdateUser();
  useSetAxiosAuthHeader();
  return null;
};
